/**
 * Role model.
 *
 * Roles are hierarchical: a role grants every permission of the roles below it.
 * Milestone 1 only ever creates `superadmin`, but the model is in place so that
 * additional roles can be handed out without a schema change.
 */
export const ROLES = ['superadmin', 'admin', 'trader', 'viewer'];
/** Higher number == more privilege. */
export const ROLE_RANK = {
    viewer: 10,
    trader: 20,
    admin: 30,
    superadmin: 40,
};
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
/** True when `role` is at least as privileged as `required`. */
export function roleAtLeast(role, required) {
    return ROLE_RANK[role] >= ROLE_RANK[required];
}
export const ROLE_LABELS = {
    superadmin: 'Super admin',
    admin: 'Admin',
    trader: 'Trader',
    viewer: 'Viewer',
};
//# sourceMappingURL=roles.js.map